import React from 'react';
import './App.css';
import reportWebVitals from '../../reportWebVitals';
import { Provider } from 'react-redux';
import LoggedInRouter from './LoggedInRouter';
import reduxConfig from './../../redux/configureStore';
import { PersistGate } from 'redux-persist/integration/react';

export default function App() {
  return (
    <Provider store={reduxConfig.store}>
      <PersistGate loading={null} persistor={reduxConfig.persistor}>
        <LoggedInRouter />
      </PersistGate>
    </Provider>
  );
}

reportWebVitals();
